import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export default function AlarmBannerNode(props) {
    const { data } = props;
    const config = data?.config || {};
    const alarmVarIds = config.alarm_variables || [];
    const alarmLiveData = data?.alarmLiveData || {};
    const alarmDetails = config.alarm_variable_details || {};

    // Legacy single-value mode when no alarm_variables configured
    if (!alarmVarIds.length) {
        const v = parseFloat(data?.liveValue ?? 0);
        const threshold = parseFloat(config.threshold ?? 1);
        const active = v >= threshold;
        const color = active ? (config.alarm_color || '#EF4444') : '#1E293B';
        const textColor = active ? '#fff' : '#475569';
        return (
            <BaseScadaNode {...props}>
                <div style={{
                    width: '100%', height: '100%', background: color, borderRadius: 4,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                    padding: '2px 8px', boxSizing: 'border-box',
                    border: `2px solid ${active ? '#EF4444' : '#334155'}`,
                    transition: 'background 0.3s',
                }}>
                    <span style={{ fontSize: 14 }}>{active ? '\uD83D\uDD34' : '\u26AB'}</span>
                    <span style={{ color: textColor, fontSize: 12, fontWeight: 600, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        {data?.label || (active ? 'ALARM' : 'Normal')}
                    </span>
                </div>
            </BaseScadaNode>
        );
    }

    // Multi-variable mode: filter to only active alarms
    const activeAlarms = alarmVarIds
        .map(vdId => ({ ...(alarmLiveData[vdId] || {}), ...(alarmDetails[vdId] || {}) }))
        .filter(v => v.high_active || v.medium_active);

    const highCount = activeAlarms.filter(v => v.high_active).length;
    const hasAlarms = activeAlarms.length > 0;
    const isHigh = highCount > 0;

    const bgColor = isHigh ? (config.alarm_color || '#EF4444') : hasAlarms ? '#F59E0B' : '#1E293B';
    const borderColor = isHigh ? '#EF4444' : hasAlarms ? '#F59E0B' : '#334155';
    const textColor = hasAlarms ? '#fff' : '#475569';
    const icon = isHigh ? '\uD83D\uDD34' : hasAlarms ? '\uD83D\uDFE1' : '\uD83D\uDFE2';

    let label;
    if (hasAlarms) {
        label = `${activeAlarms.length} Alarm${activeAlarms.length > 1 ? 's' : ''}`;
    } else {
        label = data?.label || 'All OK';
    }

    return (
        <BaseScadaNode {...props}>
            <div style={{
                width: '100%', height: '100%', background: bgColor, borderRadius: 4,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                padding: '2px 8px', boxSizing: 'border-box',
                border: `2px solid ${borderColor}`,
                transition: 'background 0.3s',
            }}>
                <span style={{ fontSize: 14 }}>{icon}</span>
                <span style={{ color: textColor, fontSize: 12, fontWeight: 600, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {label}
                </span>
            </div>
        </BaseScadaNode>
    );
}
